module.exports = __webpack_public_path__ + "img/d0f2c70d4ebd301d40bcfdfdab0235dc.png";